import React from 'react';
import styles from './style.module.css';
import { Dialog } from 'primereact/dialog';

const ReactionsModal = ({ message, visible, onHide }) => {
  // Extract reactions from message object
  const inboundEmoji = message?.inboundReaction?.reaction?.emoji;
  const outboundEmoji = message?.outboundReaction?.reaction?.emoji;
  const customerNumber = message?.phone;

  // Build unified list
  const allReactions = [];
  if (outboundEmoji) allReactions.push({ from: 'You', emoji: outboundEmoji });
  if (inboundEmoji) allReactions.push({ from: customerNumber, emoji: inboundEmoji });

  return (
    <Dialog header="Message Reactions" visible={visible} onHide={onHide}>
      <div className="flex flex-column gap-3">
        {allReactions.length > 0 ? (
          allReactions.map((r, index) => (
            <div key={index} className="flex align-items-center justify-content-between gap-2">
              <span className={styles.reactionUser}>{r.from}</span>
              <span className={styles.reactionEmoji} style={{ fontSize: '24px' }}>
                {r.emoji}
              </span>
            </div>
          ))
        ) : (
          <div className="text-center text-sm text-gray-500">No reactions yet.</div>
        )}
      </div>
    </Dialog>
  );
};

export default ReactionsModal;
